import { render, staticRenderFns } from "./CommercialClientDetail.vue?vue&type=template&id=184cbd7d&scoped=true"
import script from "./CommercialClientDetail.vue?vue&type=script&lang=js"
export * from "./CommercialClientDetail.vue?vue&type=script&lang=js"
import style0 from "./CommercialClientDetail.vue?vue&type=style&index=0&id=184cbd7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184cbd7d",
  null
  
)

export default component.exports